(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino/live-info/assets/javascripts/live-info.js') >= 0) return;  svs.modules.push('/components/casino/live-info/assets/javascripts/live-info.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (svs) {
  'use strict';

  svs = svs || {};
  svs.casino = svs.casino || {};
  svs.casino.liveInfo = svs.casino.liveInfo || {};

  svs.casino.liveInfo.interpretLiveData = function (data) {
    data.closed = data.gameState !== 1 && data.openHours && data.openHours.type !== 'FullTime';

    if (data.results && data.results.length && data.results[0].indexOf('|') > 0) {
      var r = [];
      data.results.forEach(function (v) {
        r = r.concat(v.split('|'));
      });
      data.results = r;
    }

    return data;
  };

  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    module.exports = svs.casino.liveInfo;
  }
})(svs);
 })(window);